module.exports = "/images/drybrush-logo.webp?8a96b896615aa54b6433c4db5a823a28";